'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';

import { env } from '~/env';

declare global {
  interface Window {
    _hsq: unknown[];
  }
}

const HubSpotTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      var _hsq = (window._hsq = window._hsq || []);
      if (searchParams.size === 0) {
        _hsq.push(['setPath', pathname]);
      } else {
        _hsq.push(['setPath', pathname + '?' + searchParams.toString()]);
      }
      _hsq.push(['trackPageView']);
    }
  }, [pathname, searchParams]);

  return (
    <Script
      id="hs-script-loader"
      src={`//js.hs-scripts.com/${env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID}.js`}
      strategy="afterInteractive"
    />
  );
};

export default HubSpotTracker;
